export enum APIStatus {
  IDLE = "Idle",
  PENDING = "Pending",
  REJECTED = "Rejected",
  FULFILLED = "Fulfilled",
}
